import { ProjectDetails } from '@/app/interfaces/project';
import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReviewFieldsService } from '@/app/services/ia-services/review-fields.service';
import { ReviewFieldKey } from '@/app/interfaces/review-fields.types';
import { TooltipComponent } from '@/app/shared/tooltip/tooltip.component';

@Component({
  selector: 'app-project-identification-data',
  standalone: true,
  imports: [CommonModule, TooltipComponent],
  templateUrl: './project-identification-data.component.html',
})
export class ProjectIdentificationDataComponent {
  @Input() project: ProjectDetails | null = null;
  @Input() reviewMode = false;
  @Input() readonlyReview = false;
  @Input() showPreviousReviewIndicators = false;

  constructor(public reviewFields: ReviewFieldsService) {}

  previousReviewText(fieldKey: ReviewFieldKey): string {
    return this.reviewFields.getPreviousReviewTooltipText(fieldKey);
  }
}
